export function deriveApplicationStep(pathname: string): string {
  if (pathname.startsWith("/application")) {
    return "application";
  }
  if (pathname.startsWith("/registration")) {
    return "registration";
  }
  if (pathname.startsWith("/dashboard")) {
    return "dashboard";
  }
  if (pathname.startsWith("/my-loans")) {
    return "my-loans";
  }
  if (pathname.startsWith("/path")) {
    return "path-selection";
  }
  return "other";
}
